import { render, staticRenderFns } from "./ReviewUpLimitTier.vue?vue&type=template&id=c2833cae&scoped=true"
import script from "./ReviewUpLimitTier.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimitTier.vue?vue&type=script&lang=js"
import style0 from "./ReviewUpLimitTier.vue?vue&type=style&index=0&id=c2833cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2833cae",
  null
  
)

export default component.exports